/**
 * Isofin – Herkunfts-Attribution  (Dev-Uebergabe FA-Marker, 27.07.2026)
 *
 * Merkt sich, ueber welchen Einstieg der Nutzer in den Kalkulator gekommen ist,
 * und schreibt die Herkunft als Cart-Attribut, damit sie in der Bestellung landet
 * (Order-Export: Spalte "Note Attributes"). Analog zu isofin_save_channel in
 * iso-ergebnis-share.js — gleicher, bereits bewaehrter Mechanismus.
 *
 * ── ABWEICHUNG VON DER SPEC (bewusst, verifiziert): ─────────────────────────
 *  a) KEIN globaler window.fetch-Override. Die Spec wollte ihn, weil add/change
 *     die Attribute "je nach Aufrufvariante" ueberschreiben koennten. LIVE getestet
 *     (isofin.de, 27.07.): /cart/add.js UND /cart/change.js ERHALTEN das Attribut,
 *     und /cart/update.js MERGED (isofin_source + isofin_save_channel koexistieren).
 *     Ein globaler fetch-Wrapper wuerde jeden Theme-Fetch einhuellen (Drawer,
 *     v490-Coupon-Fix, GA) und nach jedem Cart-Write ein Extra-Update feuern —
 *     unnoetiges Risiko. Einmaliges Setzen reicht.
 *  b) SOURCE_MAP erfasst zusaetzlich "analyse": Das ist der JS-lose Fallback-Link
 *     der Loesungsseiten-CTAs (data-iso-flow-open faengt normal ab und submittet
 *     als "loesung-flow"; faellt JS aus, navigiert der rohe href mit ?source=analyse).
 *     Gleiche Nutzer-Absicht, gleicher Ausgabewert -> keine Dashboard-Aenderung noetig,
 *     nur vollstaendigere FA-Zuordnung. "analyse" kommt ausschliesslich von den
 *     FA-Loesungsseiten vor (projektweit geprueft).
 *
 * ── v501 (11.08.2026): BEZAHLTER KANAL ──────────────────────────────────────
 *  Zusaetzlich wird fbclid/gclid (ersatzweise utm_source) beim ERSTEN Sehen
 *  gemerkt und an die Herkunft angehaengt. Werte im Bestell-Export:
 *    feuchtigkeitsanalyse_meta · feuchtigkeitsanalyse_google · feuchtigkeitsanalyse
 *  Begruendung und Erkennungsreihenfolge stehen unten am Erkennungsblock.
 *
 * ── v603 (12.10.2026): VOLLSTAENDIGE ZUORDNUNG ──────────────────────────────
 *  Neu in der Bestellung (alle 90 Tage gemerkt, Erstkontakt bleibt unveraendert):
 *    isofin_ad_channel_last  letzter Kanal (zuerst Google, gekauft nach Meta -> meta)
 *    isofin_ad_campaign      utm_campaign des Erstkontakts
 *    isofin_ad_campaign_last utm_campaign des letzten Kontakts
 *    isofin_berater          Berater aus dem Hendrik-Tool (Warenkorb-Link), 90 Tage gemerkt
 *  Erkennung erweitert: msclkid -> bing; utm_medium=email -> email_<quelle>
 *  (z. B. email_klaviyo), damit weitere Mail-Werkzeuge eigene Werte bekommen.
 *  Alle Merkmale gehen in EINEM Schreibvorgang in den Warenkorb.
 *
 * ── v647 (02.11.2026): EINSTIEGSSEITE + ERSTKONTAKT-KAMPAGNE ─────────────────
 *  isofin_einstieg       erste Seite der ersten Sitzung (Erstkontakt, 90 Tage)
 *  isofin_einstieg_last  Seite, auf der die letzte Anzeige gelandet ist
 *  Damit zeigt die Bestellung, ob jemand ueber /pages/keller-abdichten kam.
 *  ?source=keller-abdichten (Knoepfe der Keller-Seite) -> isofin_source keller_lp.
 *  Behoben: isofin_ad_campaign (Erstkontakt) fehlte bei Google/Meta/Bing fast immer.
 */
(function (w, d) {
  "use strict";

  var STORE_KEY = "__ISO_SOURCE__";
  var STORE_TS  = "__ISO_SOURCE_TS__";
  var STORE_CH  = "__ISO_CHANNEL__";        // v501: bezahlter Kanal (meta/google)
  var STORE_CTS = "__ISO_CHANNEL_TS__";
  var STORE_CHL = "__ISO_CHANNEL_LAST__";   // v603: letzter Kanal
  var STORE_CA  = "__ISO_CAMPAIGN__";       // v603: Kampagne Erstkontakt
  var STORE_CAL = "__ISO_CAMPAIGN_LAST__";  // v603: Kampagne letzter Kontakt
  var STORE_BER = "__ISO_BERATER__";        // v603: Berater (Hendrik-Tool), mit Link-Nr.
  var STORE_EIN  = "__ISO_EINSTIEG__";      // v647: Einstiegsseite Erstkontakt
  var STORE_EINL = "__ISO_EINSTIEG_LAST__"; // v647: Einstiegsseite der letzten Anzeige
  /* v528 (Björn 11.09.): „so lange speichern wie möglich."
     Vorher 14 Tage, begründet mit der Lebensdauer des Shopify-Warenkorbs.
     Das war der falsche Anker: Die Herkunft liegt im localStorage und hängt
     gar nicht am Warenkorb — sie überlebt ihn problemlos.

     Warum das zählt: Die Entscheidungsdauer geht bei diesen Beträgen weit
     über 14 Tage hinaus. Wer erst nach drei Wochen kauft, kam bisher ohne
     Herkunft an der Kasse an — die Bestellung trug im Export keine Quelle
     mehr. Betroffen waren ausgerechnet die großen Aufträge, denn je länger
     die Bedenkzeit, desto höher der Bestellwert.

     Jetzt 90 Tage. Das ist bewusst nicht „unbegrenzt":
       · 90 Tage ist das MAXIMUM des Klick-Conversion-Fensters in Google Ads.
         Was später kommt, rechnet kein Werbekonto mehr an — längere
         Speicherung brächte also keine zusätzliche Zuordnung, nur Rauschen.
       · Eine Herkunft von vor einem Jahr der heutigen Bestellung zuzuordnen
         wäre keine Messung mehr, sondern Erfindung.
       · Eine definierte Aufbewahrungsfrist gehört zur Datenschutz-Hygiene;
         „nie löschen" wäre hier das schwächere Argument.
     Soll es doch unbegrenzt sein: diese eine Zahl ändern. */
  var MAX_AGE   = 90 * 24 * 60 * 60 * 1000; // 90 Tage – Maximum des Google-Ads-Klickfensters
  var ATTR_KEY  = "isofin_source";          // KEIN fuehrender Unterstrich -> im Export sichtbar
  var ATTR_CH   = "isofin_ad_channel";      // A7 / v603

  // URL-Parameter -> sauberer Attributwert. Erweiterbar (z. B. "wiz-unsicher").
  var SOURCE_MAP = {
    "loesung-flow":        "feuchtigkeitsanalyse", // Regel-Pfad: Loesungsseiten-Eingabepanel (iso-loesung-flow.js)
    "analyse":             "feuchtigkeitsanalyse", // JS-loser Fallback-Link der Loesungsseiten-CTAs
    /* A3 (Auftrag 2026-09): Weg aus Kalkulator-Schritt 1 ("Ich bin mir nicht sicher",
       26-isowiz-step-1.js). Stand bisher in keiner Map -> der Umweg war weder im
       Bestell-Export noch im Trichter von der normalen FA zu unterscheiden. */
    "kalkulator-unsicher": "fa_unsicher",
    /* v647: Knoepfe der Keller-Landingpage (/pages/keller-abdichten) in Kalkulator und Analyse */
    "keller-abdichten":    "keller_lp"
  };

  function readStored() {
    try {
      var v = w.localStorage.getItem(STORE_KEY);
      var ts = parseInt(w.localStorage.getItem(STORE_TS) || "0", 10);
      if (!v || !ts) return null;
      if (Date.now() - ts > MAX_AGE) {          // abgelaufen -> aufraeumen
        w.localStorage.removeItem(STORE_KEY);
        w.localStorage.removeItem(STORE_TS);
        return null;
      }
      return v;
    } catch (e) { return null; }
  }

  function store(v) {
    try {
      w.localStorage.setItem(STORE_KEY, v);
      w.localStorage.setItem(STORE_TS, String(Date.now()));
    } catch (e) {}
  }

  /* v547.6 (24.09.2026): Frueher schrieb jeder Aufruf genau EIN Attribut. Am
     Kassenklick hingen dadurch zwei getrennte POST auf denselben Warenkorb —
     beide ohne keepalive, beide unmittelbar vor dem Seitenwechsel. Der Browser
     bricht solche Anfragen beim Wechsel ab: ausgerechnet die Herkunfts- und
     Kanal-Marker fehlten also in genau der Bestellung, fuer die sie gebaut wurden.
     Und zwei gleichzeitige Lese-Aendere-Schreibe-Vorgaenge auf denselben Warenkorb
     koennen sich gegenseitig ueberschreiben.
     Jetzt: beide Merkmale in EINEM Rumpf. /cart/update.js fuehrt Attribute zusammen,
     es geht also nichts verloren — aber es ist ein Aufruf statt zwei, was zugleich
     die bekannte 429-Drosselung von /cart/* entlastet. keepalive nur dort, wo gleich
     navigiert wird; der Rumpf liegt weit unter der 64-KB-Grenze (rund 200 Byte). */
  function setCartAttributes(attrs, mitKeepalive) {
    var opt = {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ attributes: attrs })
    };
    if (mitKeepalive) opt.keepalive = true;
    return fetch("/cart/update.js", opt).catch(function () {});
  }
  function setCartAttribute(key, val) {
    var attrs = {};
    attrs[key] = val;
    return setCartAttributes(attrs, false);
  }

  /* v491.1 (Double-Check-Haertung): NUR schreiben, wenn das Attribut fehlt.
     Grund: 2026-sticky-warenkorb.js (Z. ~1672) hat einen globalen fetch-Interceptor,
     der /cart/(add|update|change|clear) abfaengt und die Sticky-Bar neu rendert.
     Ein blindes Schreiben bei JEDEM Seitenaufruf (localStorage-Merker) wuerde die
     Sticky-Bar auf jeder Produktseite unnoetig refreshen. GET /cart.js matcht den
     Interceptor NICHT (nur /cart/<verb>), ist also nebenwirkungsfrei. Schreibt der
     GET fehl, setzen wir sicherheitshalber trotzdem (nie Attribution verlieren). */
  function ensureCartAttribute(key, val) {
    fetch("/cart.js", { credentials: "same-origin", headers: { Accept: "application/json" } })
      .then(function (r) { return r && r.ok ? r.json() : null; })
      .then(function (cart) {
        var has = cart && cart.attributes && cart.attributes[key] === val;
        if (!has) setCartAttribute(key, val);
      })
      .catch(function () { setCartAttribute(key, val); });
  }

  /* ── v501: bezahlten Kanal erkennen und merken ─────────────────────────────
     Der Marker kannte bisher nur den Einstiegsweg (Feuchtigkeitsanalyse), nicht
     die Quelle davor. In der Bestellung stand deshalb bei jeder Anzeige dasselbe.
     Der Kanal muss BEIM ERSTEN SEHEN gemerkt werden, denn die Anzeige führt auf
     eine Landingpage — der ?source-Parameter entsteht erst Klicks später, und
     fbclid/gclid sind dann längst aus der Adresszeile verschwunden.
     Erkennung in dieser Reihenfolge:
       fbclid  -> meta    (Meta hängt das an jeden Anzeigenklick)
       gclid   -> google  (dito Google Ads)
       utm_source -> Rückfallebene, falls die Klick-Kennung fehlt (z. B. weil ein
                     Browser sie entfernt) und die Anzeige eigene utm-Parameter hat.
     ERSTKONTAKT GEWINNT: ein bereits gemerkter Kanal wird nicht überschrieben —
     zugeordnet wird die Anzeige, die den Kunden gebracht hat, nicht die letzte,
     die er nebenbei noch gesehen hat.
     Der Kanal wird an die Herkunft angehängt, mit denselben 14 Tagen Haltbarkeit
     wie der Warenkorb. Ergebnis im Bestell-Export (Spalte "Note Attributes"):
       feuchtigkeitsanalyse_meta · feuchtigkeitsanalyse_google · feuchtigkeitsanalyse */
  var UTM_MAP = {
    facebook: "meta", fb: "meta", "fb-ads": "meta", meta: "meta",
    instagram: "meta", ig: "meta",
    google: "google", adwords: "google", gads: "google", "google-ads": "google"
  };

  function readChannel() {
    try {
      var v = w.localStorage.getItem(STORE_CH);
      var ts = parseInt(w.localStorage.getItem(STORE_CTS) || "0", 10);
      if (!v || !ts) return null;
      if (Date.now() - ts > MAX_AGE) {
        w.localStorage.removeItem(STORE_CH);
        w.localStorage.removeItem(STORE_CTS);
        return null;
      }
      return v;
    } catch (e) { return null; }
  }

  /* v603: Lesen/Schreiben mit 90-Tage-Ablauf fuer die neuen Merker (eigener Zeitstempel je Schluessel). */
  function lies(key) {
    try {
      var roh = w.localStorage.getItem(key);
      if (!roh) return null;
      var o = JSON.parse(roh);
      if (!o || !o.t || Date.now() - o.t > MAX_AGE) { w.localStorage.removeItem(key); return null; }
      return o.v;
    } catch (e) { return null; }
  }
  function merke(key, v) {
    try { w.localStorage.setItem(key, JSON.stringify({ v: v, t: Date.now() })); } catch (e) {}
  }
  function sauber(v, max) {
    return String(v || "").toLowerCase().replace(/[^a-z0-9._-]+/g, "_").replace(/^_+|_+$/g, "").slice(0, max || 60);
  }
  function sauberPfad(p) {
    return String(p || "/").toLowerCase().replace(/[^a-z0-9\/._-]+/g, "_").slice(0, 80) || "/";
  }
  /* v647: true, wenn der Inline-Block in theme.liquid den Kanal erst bei DIESEM Seitenaufruf
     gemerkt hat (Zeitstempel liegt nach dem Start der Seite). */
  function kanalVonDiesemAufruf() {
    try {
      var ts = parseInt(w.localStorage.getItem(STORE_CTS) || "0", 10);
      var pf = w.performance;
      var start = pf && (pf.timeOrigin || (pf.timing && pf.timing.navigationStart));
      return !!(ts && start && ts >= Math.floor(start));
    } catch (e) { return false; }
  }

  function detectChannel(sp) {
    if (sp.get("fbclid")) return "meta";
    /* gbraid/wbraid setzt Google anstelle von gclid, wenn die Klick-Kennung
       eingeschraenkt ist (iOS ohne App-Tracking). Ohne diese beiden faellt ein
       Teil der Google-Klicks stillschweigend auf "organisch" zurueck. */
    if (sp.get("gclid") || sp.get("gbraid") || sp.get("wbraid")) return "google";
    if (sp.get("msclkid")) return "bing";       // v603: Microsoft Ads Klick-Kennung
    var u = (sp.get("utm_source") || "").toLowerCase().trim();
    var med = (sp.get("utm_medium") || "").toLowerCase().trim();
    /* v603: Mail-Werkzeuge mit eigenem Wert (email_klaviyo, email_newsletter …),
       damit spaeter weitere Werkzeuge unterscheidbar bleiben. */
    if (/klaviyo/.test(u)) return "email_klaviyo";
    if (/^e-?mail$/.test(med) && u) return "email_" + sauber(u, 30);
    if (UTM_MAP[u]) return UTM_MAP[u];
    if (/facebook|instagram|meta|(^|[-_])fb([-_]|$)/.test(u)) return "meta";
    if (/google|gads|adwords|youtube/.test(u)) return "google";
    if (/bing|microsoft/.test(u)) return "bing";
    return null;
  }

  function track(name) {
    try { if (typeof w.logr3Track === "function") w.logr3Track(name, { step: true }); } catch (e) {}
  }

  /* v516-Kanal-Wrapper hier ZURUECKGENOMMEN (03.09., Audit): ein Wrapper um logr3Track sieht
     add_to_cart/checkout_start nie (kommen aus dem Web-Pixel) und verpasst wiz_loaded (feuert inline
     vor defer). Neubau inline in theme.liquid laut docs/dev-auftrag-tracking-2026-09.md, A1+A2. */

  // 1) Herkunft und Kanal aus der URL lesen und merken
  var current = null;
  var channel = null;
  try {
    var sp = new URLSearchParams(w.location.search);

    // Kanal zuerst: er kommt auf der Landingpage an, also lange vor ?source
    channel = readChannel();
    /* v603: letzter Kontakt und Kampagnen. Jede erkannte Anzeige ueberschreibt "last";
       die Kampagne des Erstkontakts wird nur beim ersten Erkennen gesetzt. */
    var jetztKanal = detectChannel(sp);
    var jetztKamp = sauber(sp.get("utm_campaign"), 60);
    /* v647: Der Inline-Block in theme.liquid merkt den Kanal schon im Seitenkopf, also bevor
       dieses Skript (defer) laeuft. "!channel" war beim Erstkontakt deshalb nie wahr, und
       isofin_ad_campaign fehlte bei Google, Meta und Bing fast immer (Bestellungen Okt. 2026:
       nur _last gesetzt). Erstkontakt = Kanal fehlte ODER wurde erst bei diesem Aufruf gemerkt. */
    var erstkontakt = !channel || kanalVonDiesemAufruf();
    var pfad = sauberPfad(w.location.pathname);
    if (jetztKanal) {
      merke(STORE_CHL, jetztKanal);
      if (jetztKamp) merke(STORE_CAL, jetztKamp);
      if (erstkontakt && jetztKamp) merke(STORE_CA, jetztKamp);
      merke(STORE_EINL, pfad);                   // v647: hier ist die Anzeige gelandet
    }
    /* v647: Einstiegsseite des Erstkontakts = erste Seite der ersten Sitzung, egal ueber welchen
       Weg; wird nicht ueberschrieben. logr3_lch setzt erst der A2-Block weiter unten. In den
       Warenkorb kommt sie nur, wenn es ohnehin Merkmale gibt (siehe Abbruch unten): kein
       zusaetzlicher Warenkorb-Verkehr fuer Besucher ohne Anzeige oder Herkunft. */
    try {
      if (!lies(STORE_EIN) && w.sessionStorage.getItem("logr3_lch") !== "1") merke(STORE_EIN, pfad);
    } catch (e) {}
    if (!channel) {                              // Erstkontakt gewinnt
      var neu = detectChannel(sp);
      if (neu) {
        channel = neu;
        try {
          w.localStorage.setItem(STORE_CH, neu);
          w.localStorage.setItem(STORE_CTS, String(Date.now()));
        } catch (e) {}
        /* A2: Kanalverteilung auch ohne Bestellung sichtbar machen. Erstkontakt ist
           immer der erste Seitenaufruf der Sitzung — ohne Warten auf die Sitzungs-ID
           ginge genau dieses Ereignis verloren (Grund fuer A4). */
        (w.isoTrackReady || track)("src_channel_" + neu, { step: true });
      }
    }

    /* A2 (Auftrag 2026-09): Einmal je Sitzung melden, mit welchem Kanal sie gelandet ist.
       Erst damit laesst sich der Trichter nach Kanal aufteilen: Sitzungen (landing_ch_*)
       gegen Kalkulator (wiz_loaded_ch_*) gegen Ergebnis (isowiz_s4_ch_*) gegen Kasse
       (checkout_result_click_ch_*). Genau diese Kette fehlte bei der Ursachensuche zum
       Einbruch vom 21.06. */
    try {
      if (w.sessionStorage.getItem("logr3_lch") !== "1") {
        w.sessionStorage.setItem("logr3_lch", "1");
        var _lch = (typeof w.isoChannel === "function" ? w.isoChannel() : (channel || "direkt"));
        (w.isoTrackReady || track)("landing_ch_" + String(_lch).replace(/[^a-z0-9]/gi, "").toLowerCase(), { step: true });
      }
    } catch (_elch) {}

    var raw = sp.get("source");
    if (raw && SOURCE_MAP[raw]) {
      current = SOURCE_MAP[raw];
      store(current);
    }
  } catch (e) {}

  // 2) Sonst: gemerkte Herkunft aus einem frueheren Besuch verwenden
  if (!current) current = readStored();
  /* v547.6 (24.09.2026): Hier stand "if (!current) return;" — und damit endete das
     Modul fuer JEDEN Besucher ohne FA-Herkunft. Verschluckt wurde dabei alles, was
     danach kommt: das Kanal-Attribut isofin_ad_channel (A7), das Nachsetzen nach
     Warenkorb-Schreibvorgaengen und die Klick-Absicherung beim Kassenklick.
     A7 wurde ausdruecklich fuer Besucher gebaut, die per gclid/fbclid direkt in den
     Kalkulator gehen — also fuer die Gruppe, die hier als Erste hinausflog. Die
     Funktion lief seit ihrem Bau nur fuer die, die sie gar nicht brauchten.
     Jetzt bricht das Modul nur ab, wenn WEDER Herkunft NOCH Kanal bekannt sind. */
  /* v603: Berater aus dem Hendrik-Tool. Der Warenkorb-Link setzt isofin_berater direkt im
     Warenkorb (Shopify), die Adresszeile verliert dabei alle Parameter. Deshalb einmal je
     Sitzung im Leerlauf den Warenkorb lesen: steht dort ein Berater, 90 Tage merken. Kauft
     der Kunde spaeter mit neuem Warenkorb, wird der Berater wieder eingetragen. */
  var berater = lies(STORE_BER);
  try {
    if (w.sessionStorage.getItem("iso_ber_chk") !== "1") {
      w.sessionStorage.setItem("iso_ber_chk", "1");
      setTimeout(function () {
        fetch("/cart.js", { credentials: "same-origin", headers: { Accept: "application/json" } })
          .then(function (r) { return r && r.ok ? r.json() : null; })
          .then(function (cart) {
            var a = cart && cart.attributes;
            if (a && a.isofin_berater) {
              berater = { n: String(a.isofin_berater).slice(0, 40), l: String(a.isofin_berater_link || "").slice(0, 40) };
              merke(STORE_BER, berater);
            }
          }).catch(function () {});
      }, 2500);
    }
  } catch (e) {}

  function sollMarker() {
    var m = {};
    if (channel) m[ATTR_CH] = channel;
    if (current) m[ATTR_KEY] = current;
    var l = lies(STORE_CHL); if (l) m.isofin_ad_channel_last = l;
    var c1 = lies(STORE_CA); if (c1) m.isofin_ad_campaign = c1;
    var c2 = lies(STORE_CAL); if (c2) m.isofin_ad_campaign_last = c2;
    if (berater && berater.n) { m.isofin_berater = berater.n; if (berater.l) m.isofin_berater_link = berater.l; }
    var e1 = lies(STORE_EIN); if (e1) m.isofin_einstieg = e1;          // v647
    var e2 = lies(STORE_EINL); if (e2) m.isofin_einstieg_last = e2;    // v647
    return m;
  }
  /* Ein GET, dann EIN Schreibvorgang mit allen fehlenden Merkmalen (nie unnoetig schreiben). */
  function ensureAll() {
    var soll = sollMarker(), keys = Object.keys(soll);
    if (!keys.length) return;
    fetch("/cart.js", { credentials: "same-origin", headers: { Accept: "application/json" } })
      .then(function (r) { return r && r.ok ? r.json() : null; })
      .then(function (cart) {
        var ist = (cart && cart.attributes) || {}, fehlt = {}, n = 0;
        keys.forEach(function (k) { if (ist[k] !== soll[k]) { fehlt[k] = soll[k]; n++; } });
        if (n) setCartAttributes(fehlt, false);
      })
      .catch(function () { setCartAttributes(soll, false); });
  }

  if (!current && !channel && !berater && !lies(STORE_CHL)) return; // nichts bekannt -> nichts zu tun

  // 2b) Kanal anhaengen, sofern bekannt (nur wenn es eine Herkunft gibt —
  //     sonst entstuende die Zeichenkette "null_google")
  if (current && channel) current = current + "_" + channel;

  // 3) Merkmale setzen — beim Seitenaufruf einmal (v603: alle in einem Vorgang).
  ensureAll();

  /* ─── A4 (v503, Dev-Auftrag 14.08.): Marker nach jedem Warenkorb-Schreibvorgang
     erneut setzen ───────────────────────────────────────────────────────────────
     Die alte Annahme "einmal pro Seitenaufruf genuegt" hat sich nicht gehalten:
     im Fenster 02.–13.08. standen 127 FA-Uebergaben nur 2 markierten Bestellungen
     gegenueber; erwartbar waeren rund 11 gewesen. Der Marker geht offenbar
     verloren, wenn der Warenkorb zwischendurch geleert oder ueber einen anderen
     Weg befuellt wird.
     Drei Absicherungen, alle ueber ensureCartAttribute (schreibt nur, wenn der
     Wert wirklich fehlt — kein unnoetiger Schreibverkehr):
       a) nach jedem eigenen Schreibzugriff auf /cart/*
       b) auf die ueblichen Shopify-Cart-Ereignisse
       c) unmittelbar vor dem Klick auf "Zur Kasse" */
  var CART_SCHREIBWEG = /\/cart\/(add|change|update|clear)(\.js)?/i;

  /* A7 (Auftrag 2026-09): zweites, unabhaengiges Attribut fuer den Werbekanal.
     isofin_source entsteht nur aus ?source=… (FA-Wege). Wer per gclid/fbclid direkt in
     den Kalkulator geht, hatte bisher gar keinen Marker — Kauf nach Kanal war im
     Bestell-Export fuer rund 90 % der Anzeigen-Sitzungen nicht rekonstruierbar. */
  /* ATTR_CH steht seit v603 oben bei ATTR_KEY (wird schon beim Seitenaufruf gebraucht). */

  function nachsetzen() {
    /* kurz warten: Shopify hat den eigenen Schreibvorgang sonst noch nicht
       abgeschlossen und wuerde unser Attribut gleich wieder ueberschreiben. */
    setTimeout(function () {
      ensureAll();
      if (current) track("src_marker_set");
    }, 400);
  }

  /* a) eigener fetch-Abfang. Nur lesen, nie verschlucken — der urspruengliche
     Aufruf laeuft unveraendert weiter. */
  try {
    if (typeof w.fetch === "function" && !w.__ISO_SRC_FETCH__) {
      w.__ISO_SRC_FETCH__ = 1;
      var origFetch = w.fetch;
      w.fetch = function (eingabe, optionen) {
        var url = "";
        try { url = typeof eingabe === "string" ? eingabe : (eingabe && eingabe.url) || ""; } catch (e) {}
        var trifft = CART_SCHREIBWEG.test(url);
        return origFetch.apply(this, arguments).then(function (antwort) {
          if (trifft) { try { nachsetzen(); } catch (e) {} }
          return antwort;
        });
      };
    }
  } catch (e) {}

  /* b) Shopify- und Theme-Ereignisse */
  try {
    ["cart:updated", "cart:refresh", "cart:change", "variant:added"].forEach(function (ev) {
      d.addEventListener(ev, nachsetzen);
    });
  } catch (e) {}

  /* c) letzte Sicherung direkt vor der Kasse. In der Erfassungsphase (capture),
     damit wir vor jedem eigenen Handler drankommen. Ohne Verzoegerung, sonst
     ist die Seite schon gewechselt. */
  try {
    d.addEventListener("click", function (e) {
      var ziel = e.target && e.target.closest
        ? e.target.closest('[name="checkout"], .cart__checkout-button, [href*="/checkout"], [data-mc-checkout]')
        : null;
      var marker = sollMarker();
      if (!ziel || !Object.keys(marker).length) return;
      /* v547.6: ein Schreibvorgang mit keepalive statt zwei ohne — siehe
         setCartAttributes(). Gleich danach wechselt die Seite zur Kasse. */
      setCartAttributes(marker, true);
      track("src_marker_set");
    }, true);
  } catch (e) {}
})(window, document);
